<template>
	<div class="main">

		<div class="header" v-if="userInfo.nickName">
			<image class="userImg" :src="userInfo.avatarUrl" mode=""></image>
			<div class='userInfo'>
				<p>{{userInfo.nickName}}</p>
			</div>
		</div>
		<div class="header" v-else>
			<image class="userImg" src="../../static/images/tabBar/my.png" mode=""></image>
			<div class='userInfo' @click='toLogin'>
				<p>未登录</p>
			</div>
		</div>

		<div class="content">
			<div class="yy">
				<div class="yy_txt">我的预约</div>
				<div class="all">全部 ></div>
			</div>

			<p class='line'></p>
			<div class="myAssetList">
				<div class='assetItem'>
					<img class="assetItem_img" src="../../static/images/tabBar/my.png" alt="">
					<span class="assetItem_txt">回馈金</span>
				</div>
				<div class='assetItem'>
					<img class="assetItem_img" src="../../static/images/tabBar/my.png" alt="">
					<span class="assetItem_txt">回馈金</span>
				</div>
				<div class='assetItem'>
					<img class="assetItem_img" src="../../static/images/tabBar/my.png" alt="">
					<span class="assetItem_txt">回馈金</span>
				</div>
			</div>
		</div>

		<div class="imgs">
			<img class="img" src="../../static/images/tabBar/tp.png" alt="">
		</div>

		<div class="floor_top">
			<div class="quan">
				<div class="quan_sty">
					<img class="quan_img1" src="../../static/kajuan.png" alt="">
					<div class="zi">福利卡/卡券</div>
				</div>
				<div>
					<span class="dy">0张</span>
					<img class="quan_img" src="../../static/youjiantou2.png" alt="">
				</div>
			</div>
			<div class="quan">
				<div class="quan_sty">
					<img class="quan_img1" src="../../static/zhuli.png" alt="">
					<div class="zi">我的助力</div>
				</div>
				<div>
					<img class="quan_img" src="../../static/youjiantou2.png" alt="">
				</div>
			</div>
			<div class="quan">
				<div class="quan_sty">
					<img class="quan_img1" src="../../static/xiaoxi.png" alt="">
					<div class="zi">我的消息</div>
				</div>
				<div>
					<img class="quan_img" src="../../static/youjiantou2.png" alt="">
				</div>
			</div>
			<div class="quan">
				<div class="quan_sty">
					<img class="quan_img1" src="../../static/baogao2.png" alt="">
					<div class="zi">我的报告</div>
				</div>
				<div>
					<img class="quan_img" src="../../static/youjiantou2.png" alt="">
				</div>
			</div>
			<div class="quan">
				<div class="quan_sty">
					<img class="quan_img1" src="../../static/guanyu.png" alt="">
					<div class="zi">关于爱康</div>
				</div>
				<div>
					<img class="quan_img" src="../../static/youjiantou2.png" alt="">
				</div>
			</div>


		</div>

		<div class="bottom">
			<div class="out">退出</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfo: {},
			}
		},
		methods: {
			toLogin() {
				uni.navigateTo({
					url: '/pages/login/login'
				})
			}
		},
		mounted() {
			this.userInfo = uni.getStorageSync('userInfo_key')
		}

	}
</script>

<style lang="scss">
	.main {
		height: 1380rpx;
		background-color: #f2f4f3;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.header {
		display: flex;
		background-color: #fd8b4d;
		padding: 40rpx 0;
		width: 100%;
	}

	.userImg {
		width: 100rpx;
		height: 100rpx;
		margin: 0 50rpx 0 30rpx;
		background-color: #fff;
		border-radius: 50rpx;
	}

	.userInfo {
		height: 50rpx;
		line-height: 50rpx;
		font-size: 28rpx;
	}

	.content {
		width: 700rpx;
		height: 300rpx;
		background-color: #fff;
		margin: 0 20rpx;
		border-radius: 15rpx;
	}

	.yy {
		display: flex;
		line-height: 90rpx;
		justify-content: space-evenly;
	}

	.yy_txt {
		font-size: 14px;
		font-weight: 600;
	}

	.all {
		margin-left: 350rpx;
		font-size: 12px;
		color: #868686;
	}

	.line {
		width: 90%;
		height: 2rpx;
		background-color: #eee;
		margin: 0 auto;
	}

	.myAssetList {
		width: 90%;
		margin: 20rpx auto;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	.assetItem {
		display: flex;
		flex-direction: column;

	}

	.assetItem_img {
		width: 100rpx;
		height: 100rpx;
		margin-bottom: 10rpx;
	}

	.assetItem_txt {
		font-size: 14px;
	}

	.imgs {
		width: 710rpx;
		height: 150rpx;
		margin-top: 20rpx;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20rpx;
	}

	.img {
		width: 710rpx;
		height: 150rpx;
	}

	.floor_top {
		width: 690rpx;
		height: 500rpx;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		border-radius: 15rpx;
		padding: 10rpx;
	}

	.quan {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.quan_sty {
		display: flex;
	}

	.quan_img1 {
		width: 45rpx;
		height: 45rpx;
	}

	.zi {
		margin-left: 30rpx;
		font-size: 14px;
		font-weight: 600;
	}

	.dy {
		font-size: 14px;
		margin-right: 10rpx;
		color: #fd8b4d;
	}

	.quan_img {
		width: 30rpx;
		height: 30rpx;
	}

	.bottom {
		width: 700rpx;
		height: 100rpx;
		margin-top: 20rpx;
		border-radius: 15rpx;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
	}
</style>
